<template>
  <section class="k2-col" :class="{ 'k2-col--one': single }" :data-c="stage.tone" :data-s="stage.key" :aria-label="label">
    <div class="k2-colh">
      <span class="k2-ci"><k2-icon :n="stage.icon" :s="19" /></span>
      <h2>{{ $t(stage.labelKey) }}</h2>
      <span class="k2-n">{{ tickets.length }}</span>
      <span v-if="lateCount" class="k2-lb" :title="tx('col.late', { n: lateCount })">
        <k2-icon n="mdi-alert-outline" :s="15" /><b>{{ lateCount }}</b>
      </span>
      <span class="k2-sp"></span>
      <button
        type="button"
        class="k2-db"
        :data-fk="'dens-' + stage.key"
        :aria-label="tx('dens.aria', { now: densName(dens), next: densName(nextDens) })"
        :title="tx('dens.title', { now: densName(dens) })"
        @click="$emit('dens', stage.key)"
      >
        <k2-icon :n="densIcon" :s="19" />
      </button>
    </div>
    <div ref="body" class="k2-colb" :class="'k2-colb--' + dens" :data-colb="stage.key" @scroll.passive="measure">
      <div v-if="!tickets.length" class="k2-empty">
        <k2-icon n="mdi-tray" :s="42" />
        <div>{{ filtered ? tx("empty.filtered") : tx("empty.none") }}</div>
      </div>
      <kds2-card
        v-for="t in tickets"
        :key="t.id"
        :t="t"
        :dens="dens"
        :now="now"
        :q="q"
        :show-rest="showRest"
        :chooser="chooserId === t.id"
        :last-est="lastEst"
        :is-new="!!newIds[t.id]"
        v-on="$listeners"
      />
    </div>
    <button v-show="moreOn" type="button" class="k2-more" @click="scrollMore">
      <k2-icon n="mdi-chevron-down" :s="18" />
      <span>{{ more ? tx("more", { n: more }) : tx("more_plain") }}</span>
    </button>
  </section>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import Kds2Card from "./Kds2Card.vue";
import kds2Text from "@/mixins/kds2Text";
import { countLate } from "@/utils/kdsTickets";

const NEXT = { full: "compact", compact: "minimal", minimal: "full" };
const ICON = { full: "mdi-view-agenda-outline", compact: "mdi-menu", minimal: "mdi-view-comfy-outline" };

// Jedna kolona: zaglavlje (broj, kasni, gustina), kartice koje se skroluju i "još N" kad ne staju.
export default {
  name: "Kds2Column",
  components: { K2Icon, Kds2Card },
  mixins: [kds2Text],
  props: {
    stage: { type: Object, required: true },
    tickets: { type: Array, required: true },
    dens: { type: String, default: "full" },
    single: { type: Boolean, default: false },
    now: { type: Number, required: true },
    q: { type: String, default: "" },
    showRest: { type: Boolean, default: false },
    chooserId: { type: Number, default: null },
    lastEst: { type: Number, default: 15 },
    newIds: { type: Object, default: () => ({}) },
    filtered: { type: Boolean, default: false },
  },
  data() {
    return { more: 0, moreOn: false };
  },
  computed: {
    nextDens() {
      return NEXT[this.dens];
    },
    densIcon() {
      return ICON[this.dens];
    },
    lateCount() {
      return countLate(this.tickets, this.now);
    },
    label() {
      return this.$t(this.stage.labelKey) + ", " + this.tickets.length;
    },
  },
  mounted() {
    this.measure();
    if (typeof ResizeObserver !== "undefined" && this.$refs.body) {
      this._ro = new ResizeObserver(() => this.measure());
      this._ro.observe(this.$refs.body);
    }
  },
  updated() {
    this.measure();
  },
  beforeDestroy() {
    if (this._ro) this._ro.disconnect();
  },
  methods: {
    densName(d) {
      return this.tx("dens." + d);
    },
    // koliko kartica je ispod donje ivice kolone ("još N")
    measure() {
      const body = this.$refs.body;
      if (!body) return;
      const over = body.scrollHeight > body.clientHeight + 6;
      const atEnd = body.scrollTop + body.clientHeight >= body.scrollHeight - 6;
      if (!over || atEnd) {
        this.moreOn = false;
        this.more = 0;
        return;
      }
      const bottom = body.getBoundingClientRect().bottom;
      let hidden = 0;
      body.querySelectorAll(".k2c").forEach((card) => {
        if (card.getBoundingClientRect().bottom > bottom + 4) hidden += 1;
      });
      this.moreOn = true;
      this.more = hidden;
    },
    scrollMore() {
      const body = this.$refs.body;
      if (body) body.scrollTo({ top: body.scrollTop + body.clientHeight - 80, behavior: "smooth" });
    },
    // automatsko listanje: do kraja, pa na početak
    pageScroll() {
      const body = this.$refs.body;
      if (!body || body.scrollHeight <= body.clientHeight + 6) return;
      const end = body.scrollTop + body.clientHeight >= body.scrollHeight - 6;
      body.scrollTo({ top: end ? 0 : body.scrollTop + body.clientHeight - 80, behavior: "smooth" });
    },
  },
};
</script>
